import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader } from '@mui/material';
import { PieChart } from '@mui/x-charts';

import { GetDashboardInfoDto } from '@bandido/shared/dtos';
import { theme } from '@frontend/theme';
import { useGetCasesNeedAgentByTimeAgo } from '../hooks/queries';

const TimeAgoColors = {
  '0-3': theme.palette.success.light,
  '3-6': theme.palette.warning.light,
  '6-12': theme.palette.warning.dark,
  '12-24': theme.palette.error.light,
  '+24': theme.palette.error.dark,
};

export const CasesNeedAgentByTimeAgoGraph = ({ startDate, endDate, agencyIds }: GetDashboardInfoDto) => {
  const { t } = useTranslation();
  const { data } = useGetCasesNeedAgentByTimeAgo({ startDate, endDate, agencyIds });

  if (!data?.data) return null;

  return (
    <Card>
      <CardHeader title={t('dashboard.casesNeedAgentByTime')} />
      <CardContent>
        <PieChart
          series={[
            {
              data: data?.data?.map((item) => ({
                id: item.timeRange,
                value: item.count,
                label: `${item.timeRange} ${t('common.hours')}`,
                color: TimeAgoColors[item.timeRange as keyof typeof TimeAgoColors],
              })),
            },
          ]}
          height={300}
        />
      </CardContent>
    </Card>
  );
};

export default CasesNeedAgentByTimeAgoGraph;
